export function testEmail(email: string): boolean {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}

export function getTimestamp(): number {
  return Math.floor(Date.now() / 1000);
}

export function solveCurrencySymbol(currencyString: string) {
  if (currencyString === "EUR") {
    return "€";
  } else if (currencyString === "GBP") {
    return "£";
  } else if (currencyString === "USD") {
    return "$";
  } else {
    return currencyString;
  }
}
